export const KEY_TOKEN = '@quadralize/token'
export const KEY_REFRESH_TOKEN = '@quadralize/refresh-token'
export const KEY_USER = '@quadralize/user'
